// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2025-2026 Daragh Farrell

import { Capacitor } from '@capacitor/core';

/** Returns true when running inside a native iOS or Android shell. */
export function isNativePlatform(): boolean {
  return Capacitor.isNativePlatform();
}

/** Returns the current platform: 'ios', 'android', or 'web'. */
export function getPlatform(): 'ios' | 'android' | 'web' {
  return Capacitor.getPlatform() as 'ios' | 'android' | 'web';
}
